import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { each, concat } from 'lodash';
import { withRouter } from 'react-router-dom';
import { fetchPrograms } from '../../../Nomination/NominationActions';
import { getPrograms } from '../../../Nomination/NominationReducer';
import ProgressBar from '../../../../components/progress-bar';
import SearchForm from '../../../../components/search-form';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import WinLossStats from '../../../Dashboard/components/WinLossStats';
import OpportunityTable from '../../../Dashboard/components/WinLossOpportunityTable';
import OpportunityModal from '../../../Dashboard/components/WinLossOpportunityTable/modal';
import SubNav from '../../components/nav';
import NumberDisplay from '../../../../components/number-display';
import WinLossOpportunityTableNav from '../../../Dashboard/components/WinLossOpportunityTableNav';
import InsightModal from '../../../Dashboard/components/InsightModal';
import RequiredTVCollectorMappingSetup from '../../../Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import { fetchTVProductMappings } from '../../../Setup/SetupActions';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';

import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';

import {
  resetAll,
  fetchWinLossOpportunities,
  fetchWinLossGlobalRankings,
  loadSettings,
} from '../../../Dashboard/DashboardActions';


import {
  getWinLossLoading,
  getWinLossLoaded,
  getWinLossOpportunities,
  getWinLossFeedbackLoaded,
  getShouldShowAllStats,
} from '../../../Dashboard/DashboardReducer';

class DashboardClosedPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectedOpportunityIds: [],
      fullScreenMode: false,
      navHeight: 0,
      opportunityFilters: null,
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.hanldeReset = this.hanldeReset.bind(this);
    this.handleStatsSelectOpportunities = this.handleStatsSelectOpportunities.bind(this);
    this.handleFilterOpportunities = this.handleFilterOpportunities.bind(this);
    this.handleOnEnterFullScreen = this.handleOnEnterFullScreen.bind(this);
    this.handleOnExitFullScreen = this.handleOnExitFullScreen.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchTVProductMappings())
      .then(
        () => {
          this.props.dispatch(fetchPrograms())
            .then(
              () => {
                this.setState({ loading: false });
              },
              () => {
                this.setState({ loading: false });
              },
            );
        },
      );
  }

  handleStatsSelectOpportunities(selectedOpportunityIds) {
    this.setState({ selectedOpportunityIds });
  }

  handleFormChange(criteria) {
    const {
      hasNoDecision,
    } = this.props;
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.props.dispatch(loadSettings());
        this.props.dispatch(fetchWinLossOpportunities({ ...criteria }, hasNoDecision))
          .then((results) => {
            const { opportunities, total } = results;
            const returnResults = opportunities.length;
            if (total && returnResults < total) {
              const el = (
                <div>
                  Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                  For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                </div>
              );
              this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
            }
            this.props.dispatch(fetchWinLossGlobalRankings(criteria));
          });
      });
  }

  hanldeReset() {
    this.props.dispatch(resetAll());
  }

  handleFilterOpportunities(opportunityFilters) {
    if (opportunityFilters) {
      this.setState({ opportunityFilters });
    }
  }

  handleOnEnterFullScreen() {
    this.setState({ fullScreenMode: true });
  }
  handleOnExitFullScreen() {
    this.setState({ fullScreenMode: false });
  }

  renderContent() {
    const {
      winLossLoading, winLossLoaded, hasNoDecision,
      opportunities, feedbackLoaded,
      shouldShowAllStats,
    } = this.props;
    const {
      fullScreenMode,
      navHeight, opportunityFilters,
    } = this.state;
    const isLoading = !winLossLoaded || winLossLoading;

    return (
      <div>
        <WinLossStats
          hasNoDecisionSetup={hasNoDecision}
          shouldShowAllStats={shouldShowAllStats}
          handleSelectOpportunities={this.handleStatsSelectOpportunities}
          feedbackLoaded={feedbackLoaded}
        />
        {isLoading && <ProgressBar />}
        {!isLoading &&
          <div>
            <WinLossOpportunityTableNav
              hasNoDecision={hasNoDecision}
              onHeightChange={(h) => {
                this.setState({ navHeight: h });
              }}
              onChange={this.handleFilterOpportunities}
              fullScreenMode={fullScreenMode}
            />
            <OpportunityTable
              tableName="dashboard-winloss-opportunities"
              opportunities={opportunities}
              isManager={shouldShowAllStats}
              feedbackLoaded={feedbackLoaded}
              onEnterFullScreen={this.handleOnEnterFullScreen}
              onExitFullScreen={this.handleOnExitFullScreen}
              fullScreenMode={fullScreenMode}
              fullScreenOffset={{ y: navHeight }}
              opportunityFilters={opportunityFilters}
            />
            <OpportunityModal
              opportunityIds={this.state.selectedOpportunityIds}
              getOpportunities={getWinLossOpportunities}
              tableConfigs={{
                isManager: shouldShowAllStats,
                tableName: 'dashboard-winloss-opportunities',
              }}
              onClose={() => {
                this.setState({ selectedOpportunityIds: [] });
              }}
            />
            <InsightModal />
            <RequestFeedbackManager />
          </div>
        }
      </div>
    );
  }

  render() {
    const {
      winLossPrograms,
      winLossLoaded, winLossLoading,
    } = this.props;
    const {
      loading,
    } = this.state;
    const hasWinLoss = winLossPrograms.length > 0;
    const isLoading = !winLossLoaded || winLossLoading;
   
    const topComponent = (
      <div className="clearfix">
        <div className="pull-left">
          <SubNav />
        </div>
        {!loading &&
          <div className="pull-right">
            <SearchForm
              onSearchChange={this.handleFormChange}
              onReset={this.hanldeReset}
              pullRight
              requireTeamSelector={false}
              selectDefaultTeam
              type="dashboard/closed"
              defaultCriteria={{
                type: 'groupAND',
                values: [
                  {
                    tag: 'closeDate',
                    type: 'include',
                    values: 'last-90-days',
                  },
                ],
              }}
              disabledFilters={[]}
              disabled={isLoading}
            />
          </div>
        }
      </div>
    );

    return (
      <div className="container">
        <RequiredTVCollectorMappingSetup types={['decision']}>
          {() => (
            <div>
              {topComponent}
              <p />
              {loading && <ProgressBar />}
              {!loading &&
                <div>
                  {!hasWinLoss &&
                    <div className="alert alert-danger">
                      No Programs found.
                    </div>
                  }
                  {hasWinLoss && this.renderContent()}
                </div>
              }
            </div>
          )}
        </RequiredTVCollectorMappingSetup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const availablePrograms = ['Win Loss', 'Voice of the Buyer', 'Customer Experience'];

  const programs = getPrograms(state);
  let winLossPrograms = [];
  if (programs) {
    each(availablePrograms, (programType) => {
      if (programs[programType] && programs[programType].length) {
        winLossPrograms = concat(winLossPrograms, programs[programType]);
      }
    });
  }
  return {
    winLossPrograms,
    winLossLoading: getWinLossLoading(state),
    winLossLoaded: getWinLossLoaded(state),
    opportunities: getWinLossOpportunities(state),
    hasNoDecision: getHasNoDecisionSetup(state),
    feedbackLoaded: getWinLossFeedbackLoaded(state),
    shouldShowAllStats: getShouldShowAllStats(null, getUser(state), getUserCurrentOrganization(state), 'workspace'),
  };
}

DashboardClosedPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  winLossPrograms: PropTypes.arrayOf(PropTypes.shape({
    program_id: PropTypes.string,
    name: PropTypes.string,
    client_id: PropTypes.string,
  })),
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  winLossLoading: PropTypes.bool,
  winLossLoaded: PropTypes.bool,
  hasNoDecision: PropTypes.bool,
  feedbackLoaded: PropTypes.bool,
  shouldShowAllStats: PropTypes.bool,
};
DashboardClosedPage.defaultProps = {
  winLossPrograms: [],
  opportunities: [],
  winLossLoading: false,
  winLossLoaded: false,
  hasNoDecision: false,
  feedbackLoaded: false,
  shouldShowAllStats: false,
};

DashboardClosedPage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(withRouter(DashboardClosedPage));
